module.exports = __webpack_public_path__ + "static/media/supplier-&-user-management.893fa35b.svg";